module.exports = __webpack_public_path__ + "img/icon_zc.3f9a4262.png";